export default function parseJsonProperties(model) {
    try {
        const properties = JSON.parse(model.jsonProperties);

        return properties || {};
    } catch {
        return {};
    }
}
